import script from "./WChatContainer.vue?vue&type=script&setup=true&lang=js"
export * from "./WChatContainer.vue?vue&type=script&setup=true&lang=js"

import "./WChatContainer.vue?vue&type=style&index=0&id=29aaf10e&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-29aaf10e"]])

export default __exports__